/**
 * DrewCore Universal AJAX Form Handler.
 *
 * Automatikusan kezeli az összes .drewcore-form osztályú űrlapot.
 * A form_type hidden input határozza meg a form típust.
 *
 * Használat HTML-ben:
 *   <form class="drewcore-form" data-form-type="kapcsolat">
 *     <input type="hidden" name="form_type" value="kapcsolat">
 *     <input type="hidden" name="lead_forras_oldal" value="<?php echo esc_url(...); ?>">
 *     <input type="text" name="lead_nev" required>
 *     <input type="email" name="lead_email" required>
 *     <input type="tel" name="lead_telefon">
 *     <textarea name="lead_uzenet"></textarea>
 *     <input type="checkbox" name="lead_adatvedelem" value="1" required>
 *     <button type="submit">Küldés</button>
 *   </form>
 *   <div class="drewcore-form-message" data-for="kapcsolat"></div>
 *
 * A form-handler.php által wp_localize_script-tel injektált drewcoreForm objektumot használja:
 *   drewcoreForm.url    -- admin-ajax.php URL
 *   drewcoreForm.action -- 'drewcore_form_submit'
 *   drewcoreForm.nonces -- { kapcsolat: '...', arajanlat: '...', stb. }
 */

(function () {
  'use strict';

  if (typeof drewcoreForm === 'undefined') return;

  var forms = document.querySelectorAll('.drewcore-form');
  if (!forms.length) return;

  for (var i = 0; i < forms.length; i++) {
    setupConditionalFields(forms[i]);
    attachFormHandler(forms[i]);
  }

  /**
   * Conditional logic: `[data-show-if-field][data-show-if-value]` wrapper-eket
   * a megadott név alapján toggleli.
   *   - Eltüntetéskor: hidden + clear value + required eltávolítása
   *   - Megjelenítéskor: hidden levétel + required visszaállítás (ha eredetileg required volt)
   *
   * A required state-et a wrapper `data-required="1"` attribútumából
   * olvassuk vissza (a PHP render állítja be).
   */
  function setupConditionalFields(form) {
    var wraps = form.querySelectorAll('[data-show-if-field]');
    if (!wraps.length) return;

    for (var i = 0; i < wraps.length; i++) {
      bindWrap(form, wraps[i]);
    }
  }

  function bindWrap(form, wrap) {
    var fieldName = wrap.getAttribute('data-show-if-field');
    var expected  = wrap.getAttribute('data-show-if-value');
    var trigger   = form.querySelector('[name="' + fieldName + '"]');
    if (!trigger) return;

    var inputs = wrap.querySelectorAll('input, textarea, select');
    var wasRequired = wrap.getAttribute('data-required') === '1';

    function update() {
      var match = String(trigger.value) === String(expected);
      if (match) {
        wrap.hidden = false;
        wrap.removeAttribute('hidden');
        for (var i = 0; i < inputs.length; i++) {
          if (wasRequired) inputs[i].required = true;
        }
      } else {
        wrap.hidden = true;
        wrap.setAttribute('hidden', '');
        for (var j = 0; j < inputs.length; j++) {
          inputs[j].required = false;
          if (inputs[j].type === 'checkbox' || inputs[j].type === 'radio') {
            inputs[j].checked = false;
          } else {
            inputs[j].value = '';
          }
        }
      }
    }

    trigger.addEventListener('change', update);
    trigger.addEventListener('input', update);
    update();
  }

  function attachFormHandler(form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var formType = form.getAttribute('data-form-type') || 'kapcsolat';
      var submitBtn = form.querySelector('[type="submit"]');
      var msgEl = document.querySelector('.drewcore-form-message[data-for="' + formType + '"]');

      if (!submitBtn) return;

      // Disable button
      var originalText = submitBtn.textContent;
      submitBtn.disabled = true;
      submitBtn.textContent = 'Küldés...';

      // Clear previous messages
      if (msgEl) {
        msgEl.textContent = '';
        msgEl.className = 'drewcore-form-message';
      }

      // Build FormData
      var formData = new FormData(form);
      formData.append('action', drewcoreForm.action);
      formData.append('nonce', drewcoreForm.nonces[formType] || '');

      // AJAX request
      var xhr = new XMLHttpRequest();
      xhr.open('POST', drewcoreForm.url, true);

      xhr.onload = function () {
        submitBtn.disabled = false;
        submitBtn.textContent = originalText;

        var response;
        try {
          response = JSON.parse(xhr.responseText);
        } catch (err) {
          showMessage(msgEl, 'Hiba történt. Próbálja újra.', 'error');
          return;
        }

        if (response.success) {
          showMessage(msgEl, response.data.message || 'Köszönjük!', 'success');
          form.reset();

          // Redirect if provided
          if (response.data.redirect) {
            setTimeout(function () {
              window.location.href = response.data.redirect;
            }, 1500);
          }
        } else {
          var errorMsg = (response.data && response.data.message) ? response.data.message : 'Hiba történt.';
          showMessage(msgEl, errorMsg, 'error');
        }
      };

      xhr.onerror = function () {
        submitBtn.disabled = false;
        submitBtn.textContent = originalText;
        showMessage(msgEl, 'Hálózati hiba. Ellenőrizze az internetkapcsolatot.', 'error');
      };

      xhr.send(formData);
    });
  }

  function showMessage(el, text, type) {
    if (!el) return;
    el.textContent = text;
    el.className = 'drewcore-form-message drewcore-form-message--' + type;

    if (type === 'error') {
      el.classList.add('text-danger');
    } else {
      el.classList.add('text-success');
    }
  }
})();
